import { FC } from 'react'

import * as Styled from './styles'
import { IFormDisclaimerProps } from './types'

export const FormDisclaimer: FC<IFormDisclaimerProps> = ({ children, name }) => (
  <Styled.Container data-testid={`form-disclaimer-${name}`}>{children}</Styled.Container>
)
